






























































































import { defineComponent, ref, computed, onMounted, onUnmounted, getCurrentInstance } from '@vue/composition-api';
import { UserIcon } from 'tdesign-icons-vue';
import userConfig from '@/renderer/components/user/components/userConfig/index.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import ipc from '@/renderer/scripts/utils/ipc';
import user from '@/renderer/scripts/utils/user';
import smh from '@/renderer/scripts/smh';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { formatSize, openConsoleInBrowser } from '@/renderer/scripts/utils/tools/index';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import { checkRoleIsAdmin } from '@/renderer/scripts/utils/UserRole';
import { checkTransBeforeQuit } from '@/renderer/scripts/utils/transmission/helper';
import { CONSTANT_URL } from '@/renderer/scripts/http';

import switchOrg from './switchOrg.vue';

export default defineComponent({
  components: {
    UserIcon,
    userConfig,
    switchOrg,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const showUserConfig = ref(false);
    const showSwitchOrg = ref(false);
    const showContent = ref(false);
    const showSignOut = ref(false);
    const store = vm.$store;
    const expiredTime = computed(() => store.getters.expireTime.split(' ')[0].replaceAll('-', '/'));
    const showRenewBtn = computed(() => checkRoleIsAdmin(store.getters.userBaseInfo.role, true));
    const popupStyle = computed(() => ({
      'box-shadow': '0px 12px 20px rgb(225 228 235 / 80%)',
      'border-radius': '8px',
      padding: store.getters.isMobileStyle ? '0px' : '13px 0 0',
      margin: '10px 0 0 0',
      width: showRenewBtn.value ? '244px' : '228px',
    }));
    const getUsed = (capacity: string, availableSpace: string) => {
      const used = Number(capacity) - Number(availableSpace || 0);
      const usedInfo = formatSize(`${used}`);
      return usedInfo;
    };
    const userAvatar = computed(() => {
      const { avatar } = store.getters.userBaseInfo;
      if (!avatar) return '';
      return avatar.includes('http') ? avatar : `${store.getters.protocol}:${avatar}`;
    });
    const userNickname = computed(() => store.getters.userBaseInfo.nickname);
    const userCapacity = computed(() => store.getters.capacity);
    const isSharedOrgSpace = computed(() => !userCapacity.value);
    const userAvailableSpace = computed(() => store.getters.availableSpace);
    const userFileSize = computed(() => store.getters.userFileSize);
    const orgCapacity = computed(() => store.getters.orgSpace);
    const orgAvaSpace = computed(() => store.getters.remainingSpaceQuota);
    const orgFileSize = computed(() => store.getters.totalFileSize);
    const isPersonal = computed(() => store.getters.editionFlag === 'personal');
    const isTeam = computed(() => store.getters.editionFlag === 'team');
    const userUsed = computed(() => {
      let usedInfo = {
        size: 0,
        unit: 'B',
      };
      if (store.getters.editionFlag === 'team') {
        usedInfo = formatSize(`${orgFileSize.value}`);
      } else {
        usedInfo = formatSize(`${userFileSize.value}`);
      }
      return `${usedInfo.size || 0}${usedInfo.unit || 'B'}`;
    });
    const userTotal = computed(() => {
      let totalInfo = {
        size: 0,
        unit: 'B',
      };
      if (userCapacity.value === '') {
        // 个人空间使用企业剩余额度
        if (['personal', 'team'].includes(store.getters.editionFlag)) {
          totalInfo = formatSize(orgCapacity.value as string);
        } else {
          totalInfo = formatSize(orgAvaSpace.value as string);
        }
      } else {
        totalInfo = formatSize(userCapacity.value as string);
      }
      return `${totalInfo.size || 0}${totalInfo.unit || 'B'}`;
    });
    const percentage = computed(() => {
      // ‘+’字符串转数字
      const used: number = +userFileSize.value || 0;
      const userTotal = userCapacity.value ? +userCapacity.value : +orgCapacity.value;
      return (used / userTotal) * 100;
    });
    const methods = {
      async onVisible(visible: boolean) {
        // 因为移动端使用点击触发，触发后，popup弹出内容不会消失，故此处进行控制移动端样式
        if (showSwitchOrg.value || showSignOut.value) {
          showContent.value = false;
          return;
        }
        showContent.value = visible;
        if (visible) {
          const { querySpaceTimestamp, hasPersonalSpace } = store.getters;
          // 没有个人空间不需要查询
          if (!hasPersonalSpace) return;
          // 离上次查询过querySpaceInterval后才再次请求
          if (new Date().getTime() - querySpaceTimestamp >= ConstantConfig.querySpaceInterval) {
            try {
              const res = await smh.userAPI.hasPersonalSpace();
              const { availableSpace = '0', capacity } = res.data;
              store.commit('SET_CAPACITY', capacity || '');
              store.commit('SET_AVAILABLE_SPACE', availableSpace);
              store.commit('SET_QUERY_TIMESTAMP', new Date().getTime());
              store.commit('SET_AVAILABLE_PERCENT', percentage.value);
            } catch (e) {
              // 不提示 展示上次请求的用量
            }
          }
        }
      },
      // 注销
      signOut() {
        showSignOut.value = true;
        showContent.value = false;
        checkTransBeforeQuit({
          alwaysShowDialog: true,
          confirmFn: () => {
            showSignOut.value = false;
            user.signOut();
          },
          closeFn: () => {
            showSignOut.value = false;
          },
        });
      },
      getUserBaseInfo() {
        store.dispatch('getUserBaseInfo');
      },
      // pc端使用浏览器打开续期页面
      openRenewPage() {
        openConsoleInBrowser();
      },
      // 打开产品反馈页
      openProductFeedbackPage() {
        dispatchRouter(CONSTANT_URL.productFeedbackUrl);
      },
    };
    const renderDropMenu = computed(() => {
      const { $route, $store } = vm;
      const openWorkbench = {
        label: i18n_t('进入网盘'),
        needDivider: vm.$route.name === 'share' || vm.$route.name === 'collect',
        show: !$store.getters.isMobileStyle,
        click: () => {
          showContent.value = false;
          dispatchRouter({
            name: 'workbench',
          });
        },
      };
      const personalSetting = {
        label: i18n_t('个人设置'),
        needDivider: vm.$route.name !== 'share',
        show: !$store.getters.isMobileStyle,
        click: () => {
          showUserConfig.value = true;
          showContent.value = false;
        },
      };
      const switchOrg = {
        label: i18n_t('切换身份'),
        show: !CONSTANT_URL.isCustomizedDomain && $store.getters.multiOrg && !$store.getters.isPrivate,
        click: () => {
          showSwitchOrg.value = true;
          showContent.value = false;
        },
      };
      const productFeedback = {
        label: i18n_t('产品反馈'),
        show: !$store.getters.isMobileStyle && !$store.getters.isPrivate,
        click: methods.openProductFeedbackPage,
      };
      const signout = {
        label: i18n_t('退出登录'),
        show: !$store.getters.isInWeMeetApp,
        click: methods.signOut,
      };
      const baseMenu: Array<{
        label: string;
        show: boolean;
        needDivider?: boolean;
        click: () => void;
      }> = [personalSetting, switchOrg, productFeedback, signout];
      if ($route.name === 'share' || $route.name === 'collect') baseMenu.unshift(openWorkbench);
      return baseMenu;
    });
    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.CURRENT_USER_INFO_CHANGED, methods.getUserBaseInfo);
      // 初始化查询一次企业额度
      store.dispatch('GetOrgSpace');
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.CURRENT_USER_INFO_CHANGED, methods.getUserBaseInfo);
    });
    return {
      showUserConfig,
      showContent,
      showSwitchOrg,
      expiredTime,
      showRenewBtn,
      userAvatar,
      userNickname,
      userCapacity,
      isSharedOrgSpace,
      userAvailableSpace,
      userUsed,
      userTotal,
      percentage,
      isPersonal,
      isTeam,
      renderDropMenu,
      popupStyle,
      ...methods,
    };
  },
});
